import React, { useContext, useEffect, useState } from "react";
import { Container, Grid, Typography } from "@mui/material";
import {
  AuthContext,
  currentAuthSession,
} from "../../components/user/BCPAuthProvider";

export default function CognitoVerification() {
  const authContext = useContext(AuthContext);
  const [bearerToken, setBearerToken] = useState(null);
  useEffect(() => {
    const go = async () => {
      var currentSession = await currentAuthSession();
      setBearerToken(currentSession?.accessTokenString);
    };
    go();
  }, []);

  return (
    <Container
      sx={{
        pt: 2,
        pb: 2,
      }}
    >
      <Typography variant="h4">User Attributes</Typography>
      <Grid container sx={{ mb: 2 }}>
        {authContext?.authState?.identity?.attributes !== undefined &&
          Object.keys(authContext?.authState?.identity?.attributes).map(
            (attribute) => {
              return (
                <>
                  <Grid item xs={4}>
                    {attribute}
                  </Grid>
                  <Grid item xs={8}>
                    {JSON.stringify(
                      authContext?.authState?.identity?.attributes[attribute]
                    )}
                  </Grid>
                </>
              );
            }
          )}
      </Grid>
      <Typography variant="h4">User Groups</Typography>
      <Grid container sx={{ mb: 2 }}>
        {authContext?.authState?.identity?.["cognito:groups"] !== undefined ? (
          authContext?.authState?.identity?.["cognito:groups"].map((group) => {
            return (
              <Grid item xs={12}>
                {group}
              </Grid>
            );
          })
        ) : (
          <Grid item xs={12}>
            No Groups
          </Grid>
        )}
      </Grid>

      <Typography variant="h4">Bearer Token</Typography>
      <Grid container sx={{ mb: 2 }}>
        <Grid item xs={12}>
          {bearerToken}
        </Grid>
      </Grid>

      <Typography variant="h4">Cognito Stats</Typography>
      <Grid container sx={{ mb: 2 }}>
        <Grid item xs={4}>
          iss
        </Grid>
        <Grid item xs={8}>
          {authContext?.authState?.identity?.iss}
        </Grid>

        <Grid item xs={4}>
          jti
        </Grid>
        <Grid item xs={8}>
          {authContext?.authState?.identity?.jti}
        </Grid>

        <Grid item xs={4}>
          accessToken
        </Grid>
        <Grid item xs={8}>
          {
            authContext?.authState?.identity?.signInUserSession?.accessToken
              ?.jwtToken
          }
        </Grid>

        <Grid item xs={4}>
          idToken
        </Grid>
        <Grid item xs={8}>
          {
            authContext?.authState?.identity?.signInUserSession?.idToken
              ?.jwtToken
          }
        </Grid>

        <Grid item xs={4}>
          refreshToken
        </Grid>
        <Grid item xs={8}>
          {
            authContext?.authState?.identity?.signInUserSession?.refreshToken
              ?.token
          }
        </Grid>
      </Grid>
    </Container>
  );
}
